<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol == 'empleado'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else xl fluid>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tableFestivos"
                        :tableName="'Días festivos'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <template slot="filters">
                            <v-col cols="12" xs="12" sm="12" md="12" class="py-0">
                                <v-text-field
                                    outlined
                                    label="Nombre"
                                    v-model="advancedSearch.nombre"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="advancedSearch.fecha_inicio"
                                    label="Fecha inicial"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaInicio"
                                />
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <VuetifyDatePicker
                                    outlined
                                    v-model="advancedSearch.fecha_final"
                                    label="Fecha final"
                                    placeholder="dd/mm/aaaa"
                                    ref="FechaFinal"
                                />
                            </v-col>
                            <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="12" class="py-0">
                                <v-autocomplete
                                    :items="clientes"
                                    item-value="id"
                                    item-text="nombre"
                                    outlined  
                                    label="Cliente" 
                                    v-model="cliente_value"                             
                                />
                            </v-col>
                            <v-col v-if="rol =='root' || rol =='admin'" cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    :items="empresas"
                                    item-value="id"
                                    item-text="nombre"
                                    outlined  
                                    label="Empresa"
                                    v-model="empresa_value"                              
                                />
                            </v-col>
                           <v-col
                              v-if="rol =='root' || rol =='admin' || rol == 'admin-empresa'"
                              cols="12"
                              xs="12"
                              :sm="rol =='admin-empresa' ? 12 : 6"
                              :md="rol =='admin-empresa' ? 12 : 6"
                              class="py-0">
                                <v-autocomplete
                                    :items="sucursales"
                                    item-value="id"
                                    item-text="nombre"
                                    outlined  
                                    label="Sucursal"   
                                    v-model="sucursal_value"                           
                                />
                            </v-col>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td v-if="rol != 'admin-sucursal' && rol != 'admin-empresa'">
                                    <div v-if="rol == 'root'" class="tblPrincipal">
                                        {{ item.nombre_empresa }}
                                    </div>
                                    <div v-if="rol == 'root'" class="tblSecundario">
                                        {{ item.sucursal }}
                                    </div>

                                    <div v-if="rol == 'admin'" class="tblPrincipal">
                                        {{ item.nombre_empresa }}
                                    </div>
                                    <div v-if="rol == 'admin'" class="tblSecundario">
                                        {{ item.sucursal }}
                                    </div>   
                                </td>
                                <td v-if="rol == 'admin-empresa'">
                                    <div class="tblPrincipal">
                                        {{ item.sucursal }}
                                    </div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">
                                        {{ item.nombre }}
                                    </div>
                                </td>

                                <td>
                                    <div class="tblPrincipal">{{ item.descripcion }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ dateFormat(item.fecha) }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="permisos.delete">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    depressed
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>

                <perfect-scrollbar style="background:#FFF">
                    <v-card elevation="0">
                        <ValidationObserver ref="form" v-slot="{ invalid }">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imagen" class="imgModal" />
                                    <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                    </div>
                                </div>

                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="8" md="8" lg="8" xl="8" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Nombre" rules="required">
                                                <v-text-field
                                                    id="primero"
                                                    autofocus
                                                    outlined
                                                    label="Nombre"
                                                    v-model="diaFestivo.nombre"
                                                    :error-messages="errors" 
                                                    required
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" class="py-0">
                                            <VuetifyDatePicker
                                                outlined
                                                rules="required"
                                                v-model="diaFestivo.fecha"
                                                label="Fecha"
                                                placeholder="dd/mm/aaaa"
                                                ref="Fecha"
                                            />
                                        </v-col>

                                        <template v-if="rol == 'root'">
                                            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Cliente" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="clientes"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Cliente"
                                                        persistent-hint
                                                        v-model="cliente_value"
                                                        required 
                                                        :error-messages="errors"
                                                    />
                                                </ValidationProvider>   
                                            </v-col>
                                        </template>

                                        <template v-if="rol == 'root' || rol == 'admin'">
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <ValidationProvider v-slot="{ errors }" name="Empresa" rules="required">
                                                    <v-autocomplete
                                                        outlined
                                                        :items="empresas"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Empresa"
                                                        persistent-hint
                                                        v-model="empresa_value"
                                                        required 
                                                        :error-messages="errors"
                                                    />
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <MultipleAutocomplete
                                                outlined
                                                :items="sucursales"
                                                :valorDefecto="sucursales_seleccionadas"
                                                item_text="nombre"
                                                @dataMultiple="(data)=> sucursales_seleccionadas = data"
                                                label="Sucursales"
                                                ref="multSucursal"
                                                />
                                            </v-col>
                                            <!-- <v-col v-else cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                outlined
                                                :items="sucursales"
                                                item-text="nombre"
                                                item-value="id"
                                                v-model="sucursal_value"
                                                label="Sucursal"
                                                />
                                            </v-col> -->
                                        </template>

                                        <template v-if="rol == 'admin-empresa'">
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <MultipleAutocomplete
                                                outlined
                                                :items="sucursales"
                                                :valorDefecto="sucursales_seleccionadas"
                                                item_text="nombre"
                                                @dataMultiple="(data)=> sucursales_seleccionadas = data"
                                                label="Sucursales"
                                                ref="multSucursal"
                                                />
                                            </v-col>
                                            <!-- <v-col v-else cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                outlined
                                                :items="sucursales"
                                                item-text="nombre"
                                                item-value="id"
                                                v-model="sucursal_value"
                                                label="Sucursal"
                                                />
                                            </v-col> -->
                                        </template>
                                        <template>
                                            <v-col cols="12" xs="12" :sm="rol != 'admin-empresa' ? 12 : 6" :md="rol != 'admin-empresa' ? 12 : 6" class="py-0">
                                                <MultipleAutocomplete
                                                    outlined
                                                    :items="departamentos"
                                                    :valorDefecto="departamentos_value"
                                                    item_text="nombre"
                                                    @dataMultiple="(data)=>departamentos_value = data"
                                                    label="Departamentos"
                                                    ref="multDepartamento"
                                                ></MultipleAutocomplete>
                                            </v-col>
                                        </template>

                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Descripción" rules="required">
                                                <v-textarea
                                                    outlined
                                                    rows="2"
                                                    label="Descripción"
                                                    v-model="diaFestivo.descripcion"
                                                    :error-messages="errors"
                                                ></v-textarea>
                                            </ValidationProvider>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()"
                                    :disabled="loading_guardar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()"
                                    :loading="loading_guardar"
                                    v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                >
                                    Guardar
                                </v-btn>
                                            
                            </v-card-actions>

                            <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                <v-alert
                                    dense
                                    outlined
                                    type="error"
                                    
                                >
                                    El usuario no tiene permiso para editar el registro.
                                </v-alert>
                            </div>
                        </ValidationObserver>
                    </v-card>
                </perfect-scrollbar>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import festivoApi from "../api/dias_festivos";
import clienteAPi from "../api/clientes";
import empresaApi from "../api/empresas";
import sucursalApi from "../api/sucursales";
import departamentoApi from "../api/departamentos";
import Notify from "@/plugins/notify";
import Datatable from "@/components/datatable/Datatable.vue";
import Multiselect from "vue-multiselect";
import VuetifyDatePicker from '@/components/VuetifyDatePicker.vue';
import MultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete2'

export default {
    name: "DiasFestivos",
    components: {
        Multiselect,
        "data-table": Datatable,
        VuetifyDatePicker,
        MultipleAutocomplete
    },
    data() {
        return {
            url: "dias-festivos/find",
            columns: [
                { label: "Nombre", name: "nombre", filterable: false },
                { label: "Descripción", name: "descripcion", filterable: true },
                { label: "Fecha", name: "fecha", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ],
            filters: {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                cliente_id      : null,
                empresa_id      : null,
                sucursal_id     : null,
                departamento_id : null,
                order_by        : 'fecha',
            },
            advancedSearch: {
                nombre          : null,
                fecha_inicio    : null,
                fecha_final     : null,
            },

            menu_inicio     : false,
            menu_inicio_C   : false,
            menu_inicio_fin : false,
            menu_final      : false,
            fecha_final     : null,
            fecha_inicio    : null,
            loading_guardar : false,
            loading         : true,
            dialog          : false,
            search          : "",
            datosLogin      : "",
            menu            : false,
            diaFestivo  : {
                id          : 0,
                nombre      : "",
                fecha       : "",
                descripcion : "",
                cliente_id  : null,
                empresa_id  : null,
                departamentos: [],
                sucursales: [],
            },
            titulo_modal    : "",
            finaliza_carga  : false,
            accion          : "",
            departamentos   : [],
            sucursales      : [],
            empresas        : [],
            clientes        : [],
            departamentos_value: [],
            sucursales_seleccionadas: [],
            departamentos_id: false,
            rol             : null,
            error_depto     : false,
            conteo_parametros: 0,
            sucursal_value  : null,
            empresa_value   : null,
            cliente_value   : null,
            diasFestivos    : [],
            diaFes          : null,
            isUpdate        : false,
            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        };
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.cambiaCliente(val);
            }
        },
        empresa_value: function(val) {
            if(this.isUpdate){
                this.sucursales_seleccionadas = []
            }
            if(val != null){
                this.cambiaEmpresa(val);
            }
        },
         sucursal_value: function(val) {
            if(val != null && this.accion == 'update'){
                this.getDepartamentos(val);
            }
        },
        sucursales_seleccionadas: function (val) {
            
            if (this.isUpdate) {
                this.departamentos_value = []
            }
            if(this.rol != 'admin-sucursal'){
                if(val != null){
                    this.getDepartamentos();
                }
            }
        },
        
    },
    methods: {
        Cambio_depto(){
            this.departamentos_id = true;
        },
        listar(parametros = null) {
            this.loading = true;
            this.cerrarModal();
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;
            //$("tr th:nth-child(2)").css("width", "35%");
            if (this.rol == "admin") {
                this.cliente_value = this.filters.cliente_id = this.datosLogin.cliente_id;
            } 
            else if (this.rol == "admin-empresa") {
                this.empresa_value = this.filters.empresa_id = this.datosLogin.empresa_id;
            } 
            else if (this.rol == "admin-sucursal") {
                this.sucursal_value = this.filters.sucursal_id = this.datosLogin.sucursal_id;
            }
        },
        formatFecha(fecha) {
            var mesesNombres = [
                "Ene",
                "Feb",
                "Mar",
                "Abr",
                "May",
                "Jun",
                "Jul",
                "Ago",
                "Sep",
                "Oct",
                "Nov",
                "Dic",
            ];
            let fecha2 = fecha.split("-");
            return fecha2[2] + " " + mesesNombres[fecha2[1] - 1] + " " + fecha2[0];
        },
        eliminar(id, nombre) {
            let self = this;
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el día festivo?",
                "Eliminar",
                () => {
                    self.loading = true;
                    festivoApi.deleteDia(id).then((response) => {
                        self.$refs.tableFestivos.getData();
                        this.respuesta_ok("El día festivo ha sido eliminado satisfactoriamente");
                    })
                    .catch((err) => {
                        self.respuesta_error(err);
                        Notify.ErrorToast(err.response.data.error);
                    });
                }
            );
        },
        async abrirModal(accion, item = null) {
            await this.resetValue();
            this.errors.clear();
            this.accion = accion;
            this.finaliza_carga = false;
            $("#primero").focus();

            if (accion == "add") {
                this.titulo_modal = "Registrar día festivo";
                this.imagen = "/static/modal/diaFestivoCreate.svg";
                this.isUpdate = true
                if (this.rol == "root") {
                this.getClientes();
                }

                if (this.rol == "admin") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.cambiaCliente(this.datosLogin.cliente_id);
                } else if (this.rol == "admin-empresa") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.cambiaEmpresa(this.datosLogin.empresa_id);
                } else if (this.rol == "admin-sucursal") {
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.sucursal_value = this.datosLogin.sucursal_id;
                    this.getDepartamentos();
                }
                this.finaliza_carga = true;
            } 
            else if (accion == "update") {
                this.titulo_modal = "Actualizar día festivo";
                this.finaliza_carga = false;
                this.imagen = "/static/modal/diaFestivoUpdate.svg";
                this.isUpdate = false
                await festivoApi.getDia(item.id).then((response) => {
                    this.diaFestivo.id = response.id;
                    this.diaFestivo.nombre = response.nombre;
                    this.diaFestivo.fecha = response.fecha;
                    this.diaFestivo.descripcion = response.descripcion;
                    this.diaFestivo.cliente_id = response.cliente_id;
                    this.diaFestivo.empresa_id = response.empresa_id;
                    this.sucursales_seleccionadas =response.sucursales;
                    this.sucursal_value = response.sucursal_id
                    this.departamentos_value = response.departamentos
                    setTimeout(()=>this.$refs.Fecha.setDate(response.fecha),200);

                    if (this.rol == "root") {
                        this.getClientes();
                    }
                    if (this.rol == "admin") {
                        this.cliente_value = this.datosLogin.cliente_id;
                        this.empresa_value = this.datosLogin.empresa_id;
                        this.cambiaCliente(this.datosLogin.cliente_id);
                    } else if (this.rol == "admin-empresa") {
                        this.cliente_value = this.datosLogin.cliente_id;
                        this.empresa_value = this.datosLogin.empresa_id;
                        this.cambiaEmpresa(this.datosLogin.empresa_id);
                    } else if (this.rol == "admin-sucursal") {
                        this.cliente_value = this.datosLogin.cliente_id;
                        this.empresa_value = this.datosLogin.empresa_id;
                        this.sucursal_value = this.datosLogin.sucursal_id;
                        this.getDepartamentos();
                    }

                    setTimeout(() => {
                        this.isUpdate = true
                        this.finaliza_carga = true
                    }, 3000);
                })
                .catch((err) => {
                    this.respuesta_error(err);
                });
            }
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        async loadModalData() {
            await this.resetValue();
            if(this.rol == 'root'){
                this.getClientes()
            }
            else if(this.rol == 'admin'){
                this.cambiaCliente(this.datosLogin.cliente_id)
                
            }

            else if (this.rol == "admin-empresa") {
                this.cambiaEmpresa(this.datosLogin.empresa_id)
            } 
            

        },
        setFilters() {
            let nombre = this.advancedSearch.nombre;
            let fecha_inicio = this.advancedSearch.fecha_inicio;
            let fecha_final = this.advancedSearch.fecha_final;
            let cliente = this.cliente_value;
            let empresa = this.empresa_value;
            let sucursal = this.sucursal_value;
            let departamento;

            if (this.rol == "admin") {
                cliente = this.datosLogin.cliente_id;
            } else if (this.rol == "admin-empresa") {
                cliente = this.datosLogin.cliente_id;
                empresa = this.datosLogin.empresa_id;
            } else if (this.rol == "admin-sucursal") {
                cliente = this.datosLogin.cliente_id;
                empresa = this.datosLogin.empresa_id;
                sucursal = this.datosLogin.sucursal_id;
            } else if (this.rol == "admin-depto") {
                cliente = this.datosLogin.cliente_id;
                empresa = this.datosLogin.empresa_id;
                sucursal = this.datosLogin.sucursal_id;
                departamento = this.datosLogin.departamento_id;
            }

            let filterParams = {
                nombre: nombre,
                min_fecha: fecha_inicio,
                max_fecha: fecha_final,
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
                cliente_id: cliente,
                empresa_id: empresa,
                sucursal_id: sucursal,
                departamento_id: departamento,
            };

            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }

            this.filters = defaultParams;

            this.advancedSearch.nombre = null;
            this.advancedSearch.fecha_inicio = null;
            this.advancedSearch.fecha_final = null;
            
        },
        async getDepartamentos(val = null) {
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
            } 
            else if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            } 
            else if (this.rol == "admin-sucursal") {
                //this.sucursal_value = this.datosLogin.sucursal_id;
                this.sucursales_seleccionadas = [this.datosLogin.sucursal_id]
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
            let param = {
                activo: true,
                paginate: false,
                cliente_id: this.cliente_value,
                empresa_id: this.empresa_value,
                //sucursal_id: this.sucursal_value,
                arraySucursal: JSON.stringify(this.sucursales_seleccionadas)
            };

            if(this.accion == 'update' && this.rol == 'admin-sucursal'){
                param.arraySucursal = JSON.stringify([this.sucursal_value])
            }
            
            
            await departamentoApi.getDepartamentos(param).then((response) => {
                this.departamentos = response.data;
                if (this.accion == "update") {
                    //this.departamentos_value = this.diaFestivo.departamentos;
                    this.diaFestivo.departamentos = [];
                    this.finaliza_carga = true;
                }
            })
            .catch((err) => {
                this.finaliza_carga = true;
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los departamentos.");
            });
        },
        getClientes(cliente = null) {
            let param = {
                activo: true,
                paginate: false,
            };

            clienteAPi.getClientes(param).then((response) => {
                this.clientes = response.data;
                if (this.diaFestivo.cliente_id != null) {
                    this.cliente_value = this.diaFestivo.cliente_id;
                }
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        async cambiaCliente(id, cliente = null) {
            let parametros = { activo: true, paginate: false, cliente_id: id };

            await empresaApi.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
                if (this.diaFestivo.empresa_id != null) {
                    this.empresa_value = this.diaFestivo.empresa_id;
                }
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        async cambiaEmpresa(id, sucursal = null) {
            let parametros = { activo: true, paginate: false, empresa_id: id };
            await sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;

                if (this.diaFestivo.sucursal_id != null) {
                    this.sucursal_value = this.diaFestivo.sucursal_id;
                }
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        async cambiaSucursal(id, sucursal = null) {
            let parametros = { activo: true, paginate: false, empresa_id: id };
            await sucursalApi.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
                if (this.accion == "update") {
                    this.sucursal_value = this.diaFestivo.sucursal_id;
                }
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        guardar() {
            this.error_depto = false;
            this.$refs.form.validate().then(result => {
                if (result) {
                    this.loading_guardar = true;
                    /* if (this.departamentos_value.length == 0) {
                        this.error_depto = true;
                        this.loading_guardar = false;
                        return;
                    } */
                    //let depto = [];
                    this.diaFestivo.cliente_id = this.cliente_value;
                    this.diaFestivo.empresa_id = this.empresa_value;

                    this.diaFestivo.sucursales = this.sucursales_seleccionadas
                    this.diaFestivo.departamentos = this.departamentos_value
                    
                    if (this.accion === "add") {
                        /* this.departamentos_value.forEach((element) => {
                            depto.push({depto_id: element,});
                            this.diaFestivo.departamentos = depto;
                        });

                        this.diaFestivo.departamentos = depto; */
                        

                        festivoApi.addDia(this.diaFestivo).then((response) => {
                            this.$refs.tableFestivos.getData();
                            this.respuesta_ok("Se ha registrado un nuevo día festivo");
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } 
                    else if (this.accion === "update") {
                        /* if(this.departamentos_id){
                            this.departamentos_value.forEach((element) => {
                                depto.push({ depto_id: element,});
                            });
                        } 
                        else{
                            this.departamentos_value.forEach((element) => {
                                depto.push({ depto_id: element["id"],});
                            });
                        }
                        this.diaFestivo.departamentos = depto; */
                        festivoApi.updateDia(this.diaFestivo).then((response) => {
                            this.$refs.tableFestivos.getData();
                            this.respuesta_ok("Se ha realizado la actualización correctamente.");
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.cliente_value = null;
            this.empresa_value = null;
            this.sucursal_value = null;
            this.resetValue();
        },
        resetValue() {
            this.error_depto = false;
            this.diaFestivo     = {
                id          : 0,
                nombre      : "",
                fecha       : "",
                descripcion : "",
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                departamentos: [],
            };
            this.departamentos_value    = [];
            this.sucursales_seleccionadas       = [];
            this.departamentos_id       = false;
            this.conteo_parametros      = 0;
            this.loading_guardar        = false;
            this.departamentos          = [];
            this.sucursales             = [];
            this.empresas               = [];
            this.clientes               = [];
            this.menu_final             = false;
            this.menu_inicio            = false;
            this.menu_inicio_C          = false;
            this.menu_inicio_fin        = false;
            this.fecha_final            = null;
            this.fecha_inicio           = null;
            if(this.rol == 'root'){
                this.cliente_value = null
            }else if(this.rol == 'admin'){
                this.empresa_value = null
                this.sucursal_value = null
            }else if(this.rol == 'admin-empresa'){
                this.sucursal_value = null
            }

            if(this.$refs.FechaInicio != undefined || this.$refs.FechaInicio != null){
                this.$refs.FechaInicio.resetDate();
            }
            if(this.$refs.FechaFinal != undefined || this.$refs.FechaFinal != null){
                this.$refs.FechaFinal.resetDate();
            }
            if(this.$refs.Fecha != undefined || this.$refs.Fecha != null){
                this.$refs.Fecha.resetDate();
            }

            this.$nextTick(() => {
                if(this.$refs.form != undefined || this.$refs.form != null){
                    this.$refs.form.reset();
                } 
            });
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj = "") {
            this.cerrarModal();
            this.listar();
            Notify.Success("Operación exitosa", msj);
        },
        async layout() {
            let self = this;
            let url = "usuarios/layout";
            const FileDownload = require("js-file-download");
            var today = new Date();
            let nombre =
                "dias_festivos_" +
                today.getDate() +
                "_" +
                (today.getMonth() + 1) +
                "_" +
                today.getFullYear() +
                "_" +
                today.getHours() +
                "-" +
                today.getMinutes() +
                "-" +
                today.getSeconds() +
                ".xlsx";
            if (this.rol == "admin-empresa") {
                var object1 = {
                    tipo: "dia_festivo",
                    rol_name: this.rol,
                    empresa_id: this.datosLogin.empresa_id,
                    sucursal_id: 0,
                };
            }
            if (this.rol == "admin-sucursal") {
                var object1 = {
                    tipo: "dia_festivo",
                    rol_name: this.rol,
                    empresa_id: this.datosLogin.empresa_id,
                    sucursal_id: this.datosLogin.sucursal_id,
                };
            }
            try {
                await Vue.axios({
                    method: "GET",
                    responseType: "blob",
                    url: url,
                    params: object1,
                }).then((response, status, xhr) => {
                    FileDownload(response.data, nombre);
                });
            } catch (e) {
                console.log(e);
            }
        },
        dateFormat(fecha) {
            let fecha2 = fecha.split("-");
            return fecha2[2] + " / " + fecha2[1]+ " / " + fecha2[0];
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("dias-festivos.store")
            this.permisos.update = permisosStorage.includes("dias-festivos.update")
            this.permisos.delete = permisosStorage.includes("dias-festivos.delete")
        },
    },
    created() {
        this.datosLogin = this.$session.get("usuario");
        this.rol = this.datosLogin.rol.name;
        this.permisosVista();

        if (this.rol == "root") {
            this.getClientes();
            
            this.columns = [
                { label: "Empresa", name: "empresa", filterable: false },
                { label: "Nombre", name: "nombre", filterable: true },
                { label: "Descripción", name: "descripcion", filterable: true },
                { label: "Fecha", name: "fecha", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ]
        }

        if (this.rol == "admin") {
            this.columns = [
                { label: "Empresa", name: "empresa", filterable: false },
                { label: "Nombre", name: "nombre", filterable: true },
                { label: "Descripción", name: "descripcion", filterable: true },
                { label: "Fecha", name: "fecha", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ]
            this.filters.cliente_id = this.datosLogin.cliente_id;
        } else if (this.rol == "admin-empresa") {
            this.columns = [
                { label: "Sucursal", name: "sucursal", filterable: false },
                { label: "Nombre", name: "nombre", filterable: true },
                { label: "Descripción", name: "descripcion", filterable: true },
                { label: "Fecha", name: "fecha", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ]
            this.empresa_value = this.filters.empresa_id = this.datosLogin.empresa_id;
        } else if (this.rol == "admin-sucursal") {
            this.filters.sucursal_id = this.datosLogin.sucursal_id;
            this.columns = [
                { label: "Nombre", name: "nombre", filterable: true },
                { label: "Descripción", name: "descripcion", filterable: true },
                { label: "Fecha", name: "fecha", filterable: true },
                { label: "Opciones", name: "opciones", filterable: false, align: 'center'},
            ]
        } else if (this.rol == "admin-depto") {
            this.filters.departamento_id = this.datosLogin.departamento_id;
        }
    },
    mounted() {
        this.listar();
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .color_rojo {
        color: red;
        margin-left: 20px;
    }
    /* oculta el icono select multiple */
    .v-list-item__action, .v-list-item__avatar, .v-list-item__icon {
        display: none !important;
    }
</style>
